import Swal from 'sweetalert2';
const axios = require('axios');

export default function(guest) {
    return new Promise((resolve, reject) => {
        // If the guest doesn't have an ID, they're probably user entered and don't need refreshing
        if (typeof guest.id == 'undefined') {
            resolve(guest);
            return;
        }
        const form = document.querySelector('#guest-list-refresh-form');
        if (!form) {
            Swal.fire({
                icon: 'error',
                title: 'Sorry, something has gone wrong',
                text: 'Please try refreshing the page. If the error persists, please contact an administrator',
            });
            reject();
            return;
        }

        axios({
            method: 'POST',
            url: form.getAttribute('action'),
            responseType: 'json',
            data: {
                id: guest.id
            }
        })
        .then(response => {
            // console.log('refresh-guest-data.js success', response);
            if (typeof response.data.status == 'undefined' || (response.data.status == 'ok' && typeof response.data.guest == 'undefined')) {
                reject();
                return;
            }
            resolve(response.data);
        })
        .catch(error => {
            const statusCode = (typeof error.response == 'undefined' || typeof error.response.status == 'undefined') ? 0 : error.response.status;
            console.error('refresh-guest-data.js statusCode', statusCode);
            if (statusCode == 404) {
                resolve({
                    status: 'deleted'
                });
                return;
            }

            if (statusCode == 422) {
                const errorMessage = (typeof error.response.data !== 'undefined' && typeof error.response.data.errors !== 'undefined' && typeof error.response.data.errors.cnaq_id !== 'undefined') ? 'min_data' : 'deleted';
                resolve({
                    status: errorMessage
                });
                return;
            }

            Swal.fire({
                icon: 'error',
                title: 'Sorry, something has gone wrong',
                text: 'Please try refreshing the page. If the error persists, please contact an administrator',
            });
            reject();
        })
    });
}